var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3271 8L10.6839 7.6497C10.8749 7.8442 10.8749 8.1558 10.6839 8.3503L10.3271 8ZM6.04309 4.3503C5.84963 4.15325 5.85253 3.83668 6.04958 3.64322C6.24663 3.44976 6.56319 3.45266 6.75666 3.6497L6.04309 4.3503ZM6.75666 12.3503C6.56319 12.5473 6.24663 12.5502 6.04958 12.3568C5.85253 12.1633 5.84963 11.8468 6.04309 11.6497L6.75666 12.3503ZM9.97037 8.3503L6.04309 4.3503L6.75666 3.6497L10.6839 7.6497L9.97037 8.3503ZM10.6839 8.3503L6.75666 12.3503L6.04309 11.6497L9.97037 7.6497L10.6839 8.3503Z",
    fill: "#4ED5D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightlogo);
export default __webpack_public_path__ + "static/media/rightlogo.2e605b5178c3ccfb3dd1ff25e967e1e1.svg";
export { ForwardRef as ReactComponent };